module.exports = __webpack_public_path__ + "img/116.77642f4b.svg";